import { FieldType } from '@pmp/api';
import { CrudMode, FormItem, SelectsOptions } from '@ohpen/enso-ui';

export const getExchangeRatesSchema = (selectsOptions: SelectsOptions, mode?: CrudMode | null): FormItem[] => [
  {
    title: 'pmp.exchangeRates.labels.sourceCurrency',
    dataIndex: 'sourceCurrency',
    valueType: 'select',
    formItemProps: {
      required: true,
    },
    fieldProps: {
      options: selectsOptions[FieldType.SOURCE_CURRENCY],
      disabled: mode === CrudMode.VIEW || mode === CrudMode.EDIT,
      showSearch: true,
    },
  },
  {
    title: 'pmp.exchangeRates.labels.targetCurrency',
    dataIndex: 'targetCurrency',
    valueType: 'select',
    formItemProps: {
      required: true,
    },
    fieldProps: {
      options: selectsOptions[FieldType.TARGET_CURRENCY],
      disabled: true,
    },
  },
  {
    title: 'pmp.exchangeRates.labels.rate',
    dataIndex: 'rate',
    valueType: 'digit',
    formItemProps: {
      required: true,
    },
    fieldProps: {
      disabled: mode === CrudMode.VIEW,
    },
  },
  {
    title: 'pmp.exchangeRates.labels.startDate',
    dataIndex: 'startDate',
    valueType: 'date',
    formItemProps: {
      required: true,
    },
    fieldProps: {
      disabled: mode === CrudMode.VIEW,
    },
  },
];
